<template>
  <div id="detail">
    <detail :item="item">
      <template slot="content">
        <div><strong>{{ $t("variables.contentLanguage") }}:</strong> {{ item.content_language }}</div>
        <div><strong>{{ $t("variables.category") }}:</strong> {{ item.category?item.category.name:'' }}</div>
        <div><strong>{{ $t("variables.contentQuantity") }}:</strong> {{ item.contents_quantity }}</div>
        <div><strong>{{ $t("variables.spec") }}</strong> {{ item.video }}</div>
        <br>
        <div><p>{{ item.description }}</p></div>
        <div v-html="item.link" />
        <br>
        <div><strong>[{{ $t("variables.episodes") }}]</strong><br>{{ item.contents }}</div>
      </template>
    </detail>
  </div>
</template>

<script>
import Detail from 'components/Detail.vue'

export default {
  components: {
    'detail': Detail
  },
  data () {
    return {
      item: {}
    }
  },
  beforeMount () {
    window.scrollTo(0, 0)
    this.getProductDetail()
  },
  methods: {
    getProductDetail: function () {
      this.$http.get('/api/products/mediacontent/' + this.$route.params.id + '/?lang=' + this.$route.params.lang)
        .then(response => {
          this.item = response.data
        })
        .catch()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/contents/MediaContentDetail.vue